import { createUseStyles } from 'react-jss'

export const useStyles = isPanelForm =>
  createUseStyles(theme => ({
    progressBar: {
      width: '90%',
      maxWidth: '600px',
      margin: '0 auto',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative',
      color: 'white',
      marginBottom: 'max(11vh, 80px)',
    },

    bar: {
      position: 'absolute',
      top: '50%',
      width: '100%',
      height: '1px',
      opacity: 0.3,
      backgroundColor: isPanelForm ? theme.colors.white : theme.colors.silver,
    },

    tabSelector: {
      flex: '0 0 63px',
      width: '63px',
      height: '63px',
      borderRadius: '50%',
      position: 'relative',
      border: '2px solid transparent',

      '& svg': {
        width: '100%',
        height: '100%',

        '& .svg-fill': { fill: isPanelForm ? theme.colors.main : theme.colors.warmGrey },
        '& .svg-stroke': { stroke: isPanelForm ? theme.colors.main : theme.colors.warmGrey },
      },

      '& p': {
        fontFamily: 'TTRounds',
        fontWeight: '700',
        fontSize: '16px',
        maxWidth: '24ch',
        position: 'absolute',
        top: '106%',
        left: '-50px',
        right: '-50px',
        textAlign: 'center',
        color: isPanelForm ? theme.colors.white : theme.colors.orange,
      },

      '&.current-tab': {
        backgroundColor: theme.colors.white,
        boxShadow: '2px 10px 30px rgba(0, 0, 0, 0.25)',
        borderColor: theme.colors.orange,

        '& svg .svg-fill': { fill: theme.colors.orange },
        '& svg .svg-stroke': { stroke: theme.colors.orange },
        '& p': { color: isPanelForm ? theme.colors.white : theme.colors.orange },
      },

      '&:not(.current-tab)': {
        '&.incomplete': {
          backgroundColor: isPanelForm ? '#87C1E7' : theme.colors.lightgrey,
          '& p': { color: isPanelForm ? '#87C1E7' : theme.colors.warmGrey },
        },

        '&.complete': {
          backgroundColor: isPanelForm ? theme.colors.white : '#87C1E7',
          '& svg .svg-fill': { fill: theme.colors.main },
          '& svg .svg-stroke': { stroke: theme.colors.main },
          '& p': { color: isPanelForm ? theme.colors.white : theme.colors.main },
        },
      },
    },
  }))
